import { useQuery } from '@tanstack/react-query';

import { dashboardV2Client } from '../api/client';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import { CalendarWeekData, DashboardFilterValues } from '../api/types';

// Browser timezone drives day-column grouping so the week the user sees
// matches their local calendar; the server falls back to America/New_York.
const browserTimeZone = () => {
  try {
    return (
      Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/New_York'
    );
  } catch {
    return 'America/New_York';
  }
};

const useCalendarWeek = (
  agencyId: number,
  startDate: string,
  filters: DashboardFilterValues,
) => {
  const timeZone = browserTimeZone();

  return useQuery<CalendarWeekData>({
    queryKey: dashboardV2QueryKeys.calendarWeek(
      agencyId,
      startDate,
      timeZone,
      filters,
    ),
    queryFn: () =>
      dashboardV2Client.getCalendarWeek({
        agencyId,
        startDate,
        timeZone,
        filters,
      }),
    enabled: agencyId != null && !!startDate,
    placeholderData: (prev) => prev,
  });
};

export default useCalendarWeek;
